import * as React from 'react';

import { requestPut } from '../../../../modules/request/index';
import { Input, } from '../../../Shared/index';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';
import DemoGuardedButton from '../shared/demoGuardedButton';

interface RenameClassModalProps {
  close: () => void;
  onSuccess: (string) => void;
  classroom: {
    id: number;
    name: string;
  };
}

export const RenameClassModal = ({ close, onSuccess, classroom }: RenameClassModalProps) => {
  const { modalRef } = useModalAccessibility(close);

  const [name, setName] = React.useState<string>(classroom.name)
  const [errors, setErrors] = React.useState<{ [key: string]: string }>({})
  const [timesSubmitted, setTimesSubmitted] = React.useState<number>(0)

  function handleNameChange(e) {
    setName(e.target.value)
  }

  function handleNameClear() {
    setName('')
  }

  function renameClass() {
    const { id } = classroom
    requestPut(`/teachers/classrooms/${id}`, { name, }, (body) => {
      if (body && body.errors) {
        setErrors(body.errors)
        setTimesSubmitted(timesSubmitted + 1)
      } else {
        onSuccess('Class renamed')
        close()
      }
    })
  }

  function submitButtonClass() {
    let buttonClass = 'quill-button contained medium green focus-on-light';
    if (!name.length || classroom.name === name) {
      buttonClass += ' disabled';
    }
    return buttonClass;
  }

  return (
    <div className="modal-container rename-class-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="renameClassModalTitle"
        aria-modal="true"
        className="rename-class-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="renameClassModalTitle">Rename your class</h3>
        </div>
        <Input
          characterLimit={50}
          className="bordered large name"
          error={errors.name}
          handleCancel={handleNameClear}
          handleChange={handleNameChange}
          id="class-name"
          label="Class name"
          timesSubmitted={timesSubmitted}
          type="text"
          value={name}
        />
        <div className="form-buttons">
          <button className="quill-button outlined medium green focus-on-light" onClick={close} type="button">Cancel</button>
          <DemoGuardedButton className={submitButtonClass()} onClick={renameClass}>Save</DemoGuardedButton>
        </div>
      </div>
    </div>
  )
}

export default RenameClassModal
